import { render, staticRenderFns } from "./ChatGPT.vue?vue&type=template&id=8005851a&"
import script from "./ChatGPT.vue?vue&type=script&lang=js&"
export * from "./ChatGPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports